<template>
  <div>
    Aktualna wersja: {{ tagName }} {{ tagInProgress }} z dnia {{ commitDate | formatDateTimeSeconds }} <br />
    Szczegóły: {{ branchName }}@{{ commitNumber }}({{ commitCount }}) <br />
    <v-img alt="Vue logo" src="@/assets/images/slide.png" />
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DisableDelayView extends Vue {
  get commitNumber(): string {
    return process.env.VUE_APP_GIT_SHORT as string;
  }
  get commitCount(): number {
    return process.env.VUE_APP_GIT_COUNT as unknown as number;
  }
  get branchName(): string {
    return process.env.VUE_APP_GIT_BRANCH as string;
  }
  get commitDate(): string {
    return process.env.VUE_APP_GIT_DATE as string;
  }
  get tagName(): string {
    return process.env.VUE_APP_GIT_TAG as string;
  }
  get tagInProgress(): string {
    return process.env.VUE_APP_GIT_TAG_IS_DIRTY ? "development" : "release";
  }
  mounted(): void {
    localStorage.removeItem("delay");
  }
}
</script>

<style scoped></style>
